import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { map } from 'rxjs/operators';

export interface PrestadoresAcreditados27Filtros {
  filAcreditado?: number;
  fil180Dias?: number;
  filRps?: number;
}

@Injectable()
export class PrestadoresAcreditados27Service {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  fetchData(
    regans: string,
    competenciaInicial: string,
    competenciaFinal: string,
    filtros: PrestadoresAcreditados27Filtros = {},
  ) {
    return this.simuladorGoApi
      .fetchRelatorioPrestadoresAcreditados27({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
        fil_acreditado: filtros.filAcreditado,
        fil_180_dias: filtros.fil180Dias,
        fil_rps: filtros.filRps,
      })
      .pipe(map(data => data.items ?? []));
  }

  getUltimoProcessamento(regans: string) {
    return this.simuladorGoApi.fetchRelatorioPrestadoresAcreditados27UltimoProcessamento({ regans });
  }
}
